import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

function parseVal(val, isDateOnly) {
  if (!val) return null;
  const s = String(val);
  if (isDateOnly) {
    const parts = s.split('T')[0].split('-');
    if (parts.length === 3) {
      return new Date(parseInt(parts[0]), parseInt(parts[1]) - 1, parseInt(parts[2]));
    }
  }
  const parts = s.replace('Z', '').split('T');
  const dp = parts[0].split('-');
  const tp = (parts[1] || '00:00').split(':');
  return new Date(parseInt(dp[0]), parseInt(dp[1]) - 1, parseInt(dp[2]), parseInt(tp[0]), parseInt(tp[1]) || 0);
}

function toDateStr(d) {
  if (!d) return null;
  const yr = d.getFullYear();
  const mo = String(d.getMonth() + 1).padStart(2, '0');
  const dy = String(d.getDate()).padStart(2, '0');
  return `${yr}-${mo}-${dy}`;
}

function toDateTimeStr(d) {
  if (!d) return null;
  const yr = d.getFullYear();
  const mo = String(d.getMonth() + 1).padStart(2, '0');
  const dy = String(d.getDate()).padStart(2, '0');
  const hr = String(d.getHours()).padStart(2, '0');
  const mn = String(d.getMinutes()).padStart(2, '0');
  return `${yr}-${mo}-${dy}T${hr}:${mn}`;
}

export default function DateTimePicker({ value, onChange, showTime = false, placeholder, required }) {
  const selected = parseVal(value, !showTime);

  function handleChange(date) {
    if (!date) { onChange(null); return; }
    onChange(showTime ? toDateTimeStr(date) : toDateStr(date));
  }

  return (
    <DatePicker
      selected={selected}
      onChange={handleChange}
      showTimeSelect={showTime}
      timeIntervals={15}
      timeFormat="h:mm aa"
      dateFormat={showTime ? 'MMM d, yyyy h:mm aa' : 'MMM d, yyyy'}
      placeholderText={placeholder || (showTime ? 'Select date & time' : 'Select date')}
      isClearable
      required={required}
      className="bb-datepicker-input"
      calendarClassName="bb-datepicker-calendar"
      popperPlacement="bottom-start"
    />
  );
}
